import { ENTERPRISE_PARTNER_ID } from '@brighte/enterprise-common/constants';
import { Box } from '@spark-web/box';
import { Divider } from '@spark-web/divider';

import { ASSET_URL, DEFAULT_LOGO_HEIGHT } from '~/constants';
import { usePartnerConfig } from '~/context/PartnerConfigContext';
import { MarketplaceChannel, MarketplacePartner } from '~/types/marketplace';
import { getBrighteSitePartnerUrl } from '~/utils/formatter';

import { BrighteLogo } from './common/brighte-logo';
import { Logo } from './logo';

export const BRIGHTE_LOGO_HEIGHT = 30;

type HeaderLogosProps = {
  channel: MarketplaceChannel | null;
  partner?: MarketplacePartner;
};

export const HeaderLogos = ({ channel, partner }: HeaderLogosProps) => {
  const config = usePartnerConfig();
  const partnerId = config?.id;
  const configuration = config?.configuration;

  const hasPartnerLogo = Boolean(partnerId && partnerId !== ENTERPRISE_PARTNER_ID.brighte);
  const hasCoBrandedLogo = Boolean(configuration?.hasCoBrandedLogo);
  const hasPartnerWebsiteUrl = Boolean(configuration?.partnerWebsiteUrl);

  if (hasCoBrandedLogo && partnerId) {
    return (
      <Box display="flex" flexDirection="row" gap="xsmall" alignItems="center">
        <a target="_blank" rel="noreferrer" href={getBrighteSitePartnerUrl(partner)} style={{ textDecoration: 'none' }}>
          <img
            src={`${ASSET_URL}/partners/${partnerId}-partnership-logo.svg`}
            alt={`${config?.name ?? 'Partner'} logo`}
            height={DEFAULT_LOGO_HEIGHT}
          />
        </a>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="row" gap="xsmall" alignItems="center">
      <Box>
        <a target="_blank" rel="noreferrer" href={getBrighteSitePartnerUrl(partner)} style={{ textDecoration: 'none' }}>
          <BrighteLogo height={BRIGHTE_LOGO_HEIGHT} />
        </a>
      </Box>
      {hasPartnerLogo ? (
        <Box display="flex" flexDirection="row" gap="medium" cursor={hasPartnerWebsiteUrl ? 'pointer' : undefined}>
          <Divider vertical />
          <Logo partner={partner} channel={channel} />
        </Box>
      ) : null}
    </Box>
  );
};
